import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

const mall = () =>
  import(
    /* webpackChunkName: "integral-mall" */ "@/views/student/integral/mall/index.vue"
  );

const taskRecord = () =>
  import(
    /* webpackChunkName: "task-record" */ "@/views/student/integral/taskRecord/index.vue"
  );

const goldRecord = () =>
  import(
    /* webpackChunkName: "gold-record" */ "@/views/student/integral/goldRecord/index.vue"
  );

const goldReceive = () =>
  import(
    /* webpackChunkName: "gold-receive" */ "@/views/student/integral/goldReceive/index.vue"
  );

const description = () =>
  import(
    /* webpackChunkName: "description" */ "@/views/student/integral/description/index.vue"
  );

const productDetail = () =>
  import(
    /* webpackChunkName: "product-detail" */ "@/views/student/integral/productDetail/index.vue"
  );

const productExchange = () =>
  import(
    /* webpackChunkName: "product-exchange" */ "@/views/student/integral/productExchange/index.vue"
  );

const exchangeRecord = () =>
  import(
    /* webpackChunkName: "exchange-record" */ "@/views/student/integral/exchangeRecord/index.vue"
  );

const learnResult = () =>
  import(
    /* webpackChunkName: "learn-result" */ "@/views/student/integral/learnResult/index.vue"
  );

const goldTask = () =>
  import(
    /* webpackChunkName: "gold-task" */ "@/views/student/integral/goldTask/index.vue"
  );

const sharePoster = () =>
  import(
    /* webpackChunkName: "share-poster" */ "@/views/student/integral/sharePoster/index.vue"
  );

const teachingSurvey = () =>
  import(
    /* webpackChunkName: "teaching-survey" */ "@/views/student/integral/teachingSurvey/index.vue"
  );

export default {
  path: "integral",
  component: view,
  children: [
    {
      path: "mall",
      component: mall
      // meta: {
      //   keepAlive: false
      // }
    },
    {
      path: "taskRecord",
      component: taskRecord
    },
    {
      path: "goldRecord",
      component: goldRecord
    },
    {
      path: "goldReceive",
      component: goldReceive
    },
    {
      path: "description",
      component: description
    },
    {
      path: "productDetail",
      component: productDetail
    },
    {
      path: "productExchange",
      component: productExchange
    },
    {
      path: "exchangeRecord",
      component: exchangeRecord
    },
    {
      path: "learnResult",
      component: learnResult
    },
    {
      path: "goldTask",
      component: goldTask
    },
    {
      path: "sharePoster",
      component: sharePoster
    },
    {
      path: "teachingSurvey",
      component: teachingSurvey
    }
  ]
};
